"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.THEME = exports.BREAKPOINTS_SCALE = exports.FONT_SCALE_UNIT = exports.BASE_FONT_SIZE = exports.ROOT_FONT_SIZE = exports.FONT_SCALE = exports.SPACE_SCALE_UNIT = exports.SPACE_SCALE = exports.SCHEMES = exports.DARK = exports.LIGHT = exports.CONSTANTS = void 0;
exports.CONSTANTS = {
    black: "black",
    white: "white",
};
exports.LIGHT = __assign({ primary: "#000000", border: "#000000", secondary: "#7a7a7a", tertiary: "#bfbfbf", hint: "#e1e1e1", danger: "#db0000", background: "#ffffff", accent: "#6fdd00", external: "#0000d9" }, exports.CONSTANTS);
exports.DARK = __assign({ primary: "#ffffff", border: "#ffffff", secondary: "#a0a0a0", tertiary: "#6c6c6c", hint: "#3f3f3f", danger: "#ff3e3e", background: "#000000", accent: "#23cf00", external: "#1c8bf2" }, exports.CONSTANTS);
exports.SCHEMES = {
    dark: exports.DARK,
    light: exports.LIGHT,
};
exports.SPACE_SCALE = [
    "0",
    "0.125rem",
    "0.25rem",
    "0.5rem",
    "0.75rem",
    "1rem",
    "1.5rem",
    "2rem",
    "4rem",
    "8rem",
    "16rem", // 10
];
exports.SPACE_SCALE_UNIT = "rem";
exports.FONT_SCALE = [
    "0.75rem",
    "0.875rem",
    "1rem",
    "1.125rem",
    "1.5rem",
    "2rem", // 5 = 32px
];
exports.ROOT_FONT_SIZE = "16px";
exports.BASE_FONT_SIZE = exports.FONT_SCALE[2];
exports.FONT_SCALE_UNIT = "rem";
exports.BREAKPOINTS_SCALE = [
    "30em",
    "48em",
    "62em",
    "80em", // below 1200px
];
exports.THEME = {
    fonts: {
        body: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        mono: "SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
    },
    scheme: "light",
    colors: exports.LIGHT,
    fontSizes: exports.FONT_SCALE,
    rootFontSize: exports.ROOT_FONT_SIZE,
    lineHeights: [1, 1.25, 1.33, 1.75],
    space: exports.SPACE_SCALE,
    breakpoints: exports.BREAKPOINTS_SCALE,
};
//# sourceMappingURL=theme.js.map